<template>
    <div class="mt-4">
        <template v-if="invoices">
            <div v-if="!!invoices.length" class="table-responsive">
                <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                        <th width="180" class="border-top-0">{{ $t('bills.date') }}</th>
                        <th class="border-top-0">{{ $t('bills.description') }}</th>
                        <th width="150" class="border-top-0 text-center">{{ $t('bills.action') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(invoice, i) in invoices" :key="i">
                        <td>{{ invoice.order_date | moment('DD.MM.YYYY HH:mm') }}</td>
                        <td>{{ $t('bills.invoice', {number: invoice.invoice_number}) }}</td>
                        <td>
                            <b-dropdown id="dropdown-right" right :text="$t('bills.choose_action')"
                                        variant="light" class="m-2">
                                <b-dropdown-item to="" @click.prevent="goTo(invoice.customer_view_url)" target="_blank">
                                    <!--<span class="material-icon icon-search"></span>-->
                                    {{ $t('bills.preview') }}
                                </b-dropdown-item>
                                <b-dropdown-item to="" @click.prevent="goTo(invoice.pdf_url)">
                                    <!--<span class="material-icon icon-cloud_download"></span>-->
                                    {{ $t('bills.download') }}
                                </b-dropdown-item>
                            </b-dropdown>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-else class="alert alert-info">{{ $t('no_data') }}</div>
        </template>
    </div>
</template>

<script>
  import invoices from 'src/mixins/invoicesComponent';

  export default {
    mixins: [invoices],
  };
</script>